import { NavLink } from "react-router-dom";
import cn from "classnames";

// Switches between the staff portal's top-level pages. Rendered in the header
// of each one so there is always a way across.
const ITEMS = [
  { to: "/agency-management", label: "Agencies", end: true },
  { to: "/agency-management/usage", label: "Usage", end: false },
];

export default function StaffNav({ className }: { className?: string }) {
  return (
    <nav aria-label="Staff portal" className={cn("inline-flex rounded-lg bg-base-200 p-1 gap-1", className)}>
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              "rounded-md px-3 py-1 text-sm font-medium no-underline transition-colors",
              isActive ? "bg-base-100 text-base-content shadow-sm" : "text-base-content/60 hover:text-base-content"
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
